module.exports = __webpack_public_path__ + "img/84-nap-1.46e670a3.jpg";